/**
 * Unsent composer text per tab (#182), for the life of the page — so
 * switching tabs and coming back finds the draft where it was.
 *
 * Cleared on a workspace switch: a draft typed under one account or org
 * must not greet the next one in the same browser session.
 */
import { useComposerReply } from './simple/composerReply';

const drafts = new Map<string, string>();
const listeners = new Set<(key?: string) => void>();

/**
 * A mounted composer subscribes so a clear reaches the text on screen too. A
 * fill names its key: only that key's composer takes it (#1504).
 */
export function subscribeDrafts(listener: (key?: string) => void): () => void {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}

export function getDraft(key: string): string {
  return drafts.get(key) || '';
}

export function setDraft(key: string, value: string): void {
  if (value) drafts.set(key, value);
  else drafts.delete(key);
}

/** Puts text in a composer from elsewhere (#1514's search palette): a mounted composer shows it at once. */
export function handDraft(key: string, value: string): void {
  setDraft(key, value);
  listeners.forEach((l) => { try { l(); } catch { /* one listener must not block the rest */ } });
}

export function clearDrafts(): void {
  drafts.clear();
  // a reply from Correct this (#1508) is part of the draft
  useComposerReply.getState().clearReplies();
  listeners.forEach((l) => { try { l(); } catch { /* one listener must not block the rest */ } });
}

/**
 * Puts text into a key's draft AND into its mounted composer (#1504), without
 * remounting it: whatever else the composer holds (an attached file) stays.
 */
export function fillDraft(key: string, value: string): void {
  setDraft(key, value);
  listeners.forEach((l) => { try { l(key); } catch { /* one listener must not block the rest */ } });
}
